import React, { useEffect } from "react";

import Logo from "src/common/containers/NavBar/Logo/Logo";

import * as S from "./Layout.styles";

export const Layout = ({ children }) => {
  useEffect(() => {
    document.getElementById("pre-loading")?.remove();
    document.getElementById("fallback")?.remove();
  }, []);

  return (
    <S.Layout data-testid="subscribe-layout-wrapper">
      <S.Header>
        <Logo isFullLogo />
      </S.Header>
      {children}
    </S.Layout>
  );
};
